import { Match } from '@/domain/models/Match';

const MATCH_PENDING_DELETE_MS = 3 * 24 * 60 * 60 * 1000;

export function closeMatch(match: Match, closeByUserId: number): Match {
  return {
    ...match,
    status: 'CLOSED',
    closed_by_user_id: closeByUserId,
    pending_delete_at: Number(new Date(Date.now() + MATCH_PENDING_DELETE_MS)),
  };
}
